import { Component, OnDestroy } from '@angular/core';
import { FrequencyRange, SimpleMessageService, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Subscription } from 'rxjs';
import { Router } from "@angular/router";
import { RanConfigurationService } from "../../services/ran-configuration.service";
import { RanConfigurationDto } from "../../models/ran-configuration/ran-configuration-dto";
import { AvailableRoutes } from "../../enums/available-routes";
import { RanConfigurationFormComponent } from '../../components/ran-configuration-form/ran-configuration-form.component';

@Component({
    selector: 'oaibox-gnb-default-configuration-page',
    templateUrl: './gnb-default-configuration-page.component.html',
    styleUrls: ['./gnb-default-configuration-page.component.css'],
    imports: [RanConfigurationFormComponent, WebAppCommonModule]
})
export class GnbDefaultConfigurationPageComponent implements OnDestroy {

  public selectedFrequencyRange: FrequencyRange = FrequencyRange.FR1;
  public AVAILABLE_FREQUENCY_RANGES = Object.values(FrequencyRange);

  public defaultRanConfiguration?: RanConfigurationDto;
  public defaultRanConfigurationSubscription?: Subscription;
  public saveDefaultRanConfigurationSubscription?: Subscription;

  public requestOnGoing: boolean = false;

  constructor(
    private ranConfigurationService: RanConfigurationService,
    private router: Router,
    private simpleMessageService: SimpleMessageService
  ) {
    this.fetchConfiguration(this.selectedFrequencyRange);
  }

  public fetchConfiguration(frequencyRange: FrequencyRange): void {
    this.selectedFrequencyRange = frequencyRange;
    this.defaultRanConfigurationSubscription?.unsubscribe();
    this.defaultRanConfigurationSubscription = this.ranConfigurationService.fetchDefaultRanConfiguration(frequencyRange)
      .subscribe({
        next: ranConfiguration => this.defaultRanConfiguration = ranConfiguration,
        error: _ => this.defaultRanConfiguration = undefined,
      });
  }

  public updateConfiguration(defaultConfiguration: RanConfigurationDto) {
    this.defaultRanConfiguration = defaultConfiguration;
  }

  public saveDefaultConfiguration(): void {
    if (this.defaultRanConfiguration) {
      this.requestOnGoing = true;
      this.saveDefaultRanConfigurationSubscription?.unsubscribe();
      this.saveDefaultRanConfigurationSubscription = this.ranConfigurationService
        .createOrUpdateDefaultRanConfiguration(this.defaultRanConfiguration, this.selectedFrequencyRange)
        .subscribe({
          next: () => {
            this.requestOnGoing = false;
            this.simpleMessageService.showSimpleMessage({
              message: 'gNB Default Configuration saved Successfully!',
              icon: 'fa-solid fa-check-double',
              color: 'success',
            })
          },
          error: () => {
            this.requestOnGoing = false;
            this.simpleMessageService.showSimpleMessage({
              message: 'gNB Default Configuration not saved!',
              icon: 'fa-solid fa-triangle-exclamation',
              color: 'danger',
            })
          },
        });
    }
  }

  public goBack(): void {
    this.router.navigate([AvailableRoutes.ADMIN, AvailableRoutes.DEPLOYMENTS]);
  }

  ngOnDestroy(): void {
    this.defaultRanConfigurationSubscription?.unsubscribe();
    this.saveDefaultRanConfigurationSubscription?.unsubscribe();
  }

}
